import { render, staticRenderFns } from "./ClaimAddWalletSending.vue?vue&type=template&id=280830d2&scoped=true&"
import script from "./ClaimAddWalletSending.vue?vue&type=script&lang=js&"
export * from "./ClaimAddWalletSending.vue?vue&type=script&lang=js&"
import style0 from "./ClaimAddWalletSending.vue?vue&type=style&index=0&id=280830d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280830d2",
  null
  
)

export default component.exports